export default __webpack_public_path__ + "static/media/EM0150.34I-21071_-15292_0.ffec8726.jpg";